import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useGateTestStyles = makeStyles(() => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },
  mainContainer: {
    flex: 1,
    display: "flex",
    overflow: "hidden",
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  questionContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: {
      xs: "auto",
      md: "hidden",
    },
  },
  collapseToggleContainer: {
    display: {
      xs: "none",
      md: "flex",
    },
    position: "relative",
    display: "flex",
    alignItems: "center !important",
    justifyContent: "center",
    // paddingRight:"2px"
  },
  toggleBox: {
    display: {
      xs: "none",
      md: "flex",
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "black",
    padding: "15px 0px",
    position: "absolute",
    right: "0px",
    cursor: "pointer",
    borderRadius: "4px",
    width: "15px",
  },
  sidebarContainer: {
    display: {
      xs: "none",
      md: "block",
    },
    width: "300px",
    flexShrink: 0,
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0px",
    },
  },
  mobileDrawer: {
    display: {
      xs: "block",
      md: "none",
    },
    "& .MuiDrawer-paper": {
      width: "300px",
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  img: {
    "& img": {
      width: "60% !important",
    },
  },
}));

export default useGateTestStyles;
